import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_HOW_TO_STEPS } from '@/app/donation/constants';
import { DONATION_BENEFIT_TEXT } from '@/components/server/HometownDonationNotice/getHometownDonationNotice';
import { DONATION_ROUTES } from '@/constants';
interface RegionHowToDonateProps {
  institutionName: string;
  className?: string;
}
export const RegionHowToDonate = t0 => {
  const $ = _c(12);
  const {
    institutionName,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== institutionName) {
    t2 = <h2 className="break-keep font-700 text-Gray-900 typo-h6">{institutionName} 고향사랑기부 하는 법</h2>;
    $[2] = institutionName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="break-keep text-Gray-700 typo-body3 mobile-tablet:typo-body4">{DONATION_BENEFIT_TEXT}</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="flex flex-col gap-4">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ol className="m-0 grid list-none grid-cols-3 gap-12 p-0 mobile-tablet:grid-cols-1">{DONATION_HOW_TO_STEPS.map(_temp)}</ol>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button asChild={true} theme="sub-line" dimensions="H48" className="w-full"><CustomLink href={DONATION_ROUTES.GUIDE.pathname}>고향사랑기부 방법 자세히 보기</CustomLink></Button>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t4) {
    t7 = <section className={t1}>{t4}{t5}{t6}</section>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
function _temp(step, index) {
  return <li key={step.title} className="flex flex-col gap-8 rounded-large bg-Gray-50 p-20"><span className="font-700 text-O-400 typo-body4">{String(index + 1).padStart(2, "0")}</span><strong className="break-keep font-700 text-Gray-900 typo-body3">{step.title}</strong><p className="break-keep text-Gray-600 typo-body4">{step.description.join(" ")}</p></li>;
}